import React from 'react';
import i18n from 'i18next';

import { sentryCaptureException } from 'sentry.js';
import * as clientErrTypes from 'config/clientErrorTypes';
import { isChunkLoadError } from 'client/utils/errorObjectChecker';

const ignoreErrorMessage = [];

// 可以透過 error stack 去判斷是否為外部檔案造成的 error 並過濾
const ignoreErrorStack = ['gtm.js'];

export default class ErrorBoundaryApp extends React.Component {
    state = {
        hasError: false,
        code: '',
        isCrashDueToOldCache: false
    };

    static getDerivedStateFromError(error) {
        const isCrashDueToOldCache = isChunkLoadError(error);
        return { hasError: true, isCrashDueToOldCache };
    }

    componentDidCatch(error, errorInfo) {
        const { isCrashDueToOldCache } = this.state;
        if (!isCrashDueToOldCache) {
            if (errorInfo?.componentStack) console.log('componentStack:', errorInfo.componentStack);
            error.extraInfo = {
                ...errorInfo,
                errType: clientErrTypes.COMPONENT_CRASH
            };
            try {
                const { message = '' } = error;
                console.log('error message:', message);
                if (ignoreErrorMessage.some(text => message.includes(text))) return;

                const errorStack = error?.error?.stack || '';
                console.log('error.error.stack:', error?.error?.stack);
                if (ignoreErrorStack.some(text => errorStack.includes(text))) return;
            } catch (error) {}

            const eventId = sentryCaptureException(error);
            this.setState({ code: eventId });
        }
    }

    render() {
        const { hasError, code, isCrashDueToOldCache } = this.state;
        const title = i18n.t(
            isCrashDueToOldCache
                ? 'label.err_boundary.failed_to_load'
                : 'label.err_boundary.sth_went_wrong'
        );

        if (hasError) {
            return (
                <div style={containerStyle}>
                    <h1 style={alignTextCenter}>{title}</h1>
                    {Boolean(code) && (
                        <h3 style={alignTextCenter}>{`${i18n.t('label.error_code')}: ${code}`}</h3>
                    )}
                    {isCrashDueToOldCache && (
                        <button style={btnStyle} onClick={() => window.location.reload()}>
                            {i18n.t('btn.reload')}
                        </button>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

const containerStyle = {
    padding: '16px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255,255, 0.5)'
};
const btnStyle = {
    padding: '8px 16px',
    borderRadius: '4px',
    border: '1px solid black',
    backgroundColor: 'transparent',
    cursor: 'pointer'
};
const alignTextCenter = {
    textAlign: 'center',
    wordBreak: 'break-word'
};
